/* import __COLOCATED_TEMPLATE__ from './all-locations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();